import React from "react";
import { HedgeFarmApiService, PerformanceData } from "src/rest/hedgeFarm";
import { Strategy } from "../types";

export const usePerformanceData = (strategy: Strategy) => {
    const hedgeFarmApiService = new HedgeFarmApiService(strategy);
    const [performanceData, setPerformanceData] = React.useState<PerformanceData>();

    const fetchPerformanceData = async () => {
        try {
            setPerformanceData(await hedgeFarmApiService.getPerformance());
        } catch (e) {
            console.error(`Failed to fetch performance data: ${e}`);
        }
    };

    React.useEffect(() => {
        fetchPerformanceData();
    }, [strategy]);

    return { performanceData };
};
